module.exports = __webpack_public_path__ + "static/media/fresh-tomatoes.4161da46.jpg";